export const FIELDS_NAME = {
  FEDERAL_STATES: 'federalStates',
  NATIVE_RESIDENT: 'nativeResident',
  STATE: 'state',
  ADDRESS_COUNTRY: 'addressCountry',
  TITLE: 'title',
  JOB_TITLE: 'jobTitle',
  PREVIOUS_NAMES: 'previousNames',
  COUNTRY_OF_BIRTH: 'countryOfBirth',
  DEPARTMENT: 'department',
  FACE_PHOTO: 'facePhoto',
  PHOTO: 'photo',

};

// Field codes that represent a facePhoto/Photo upload. Uploads for these fields
// must include the isFacePhoto flag and the current projectId.
export const FACE_PHOTO_FIELD_CODES = [FIELDS_NAME.FACE_PHOTO, FIELDS_NAME.PHOTO];

export const isFacePhotoField = (fieldCode?: string): boolean =>
  FACE_PHOTO_FIELD_CODES.some(
    (code) => code.toLowerCase() === (fieldCode ?? '').toLowerCase(),
  );
